/** 全局 API 请求计数：任意通过 compliance.ts trackedFetch 发出的请求都会 bump，供全屏 Spin 使用。 */

let activeRequests = 0;
const listeners = new Set<() => void>();

function emit() {
  for (const l of listeners) {
    l();
  }
}

export function beginApiLoading(): void {
  activeRequests += 1;
  emit();
}

export function endApiLoading(): void {
  activeRequests = Math.max(0, activeRequests - 1);
  emit();
}

export function subscribeApiLoading(onStoreChange: () => void): () => void {
  listeners.add(onStoreChange);
  return () => listeners.delete(onStoreChange);
}

export function getApiLoadingSnapshot(): boolean {
  return activeRequests > 0;
}

export function getApiLoadingServerSnapshot(): boolean {
  return false;
}
